import { getArchiveIdByPostType, getFrontPageID } from '@/helpers/helpers'

export default {

    pageIsLoading: state => state.pageIsLoading,
    //getPosts: state => state.postsData,
    getCurrentRoute: state => state.route,
    getStoreVersion: state => state.storeVersion,
    loadedEverything: state => state.loadedEverything,
    loadedTaxonomies: state => state.taxonomies,
    isLoadedEverything: state => state.loadedEverything.status,
    isLoadingEverything: state => state.loadedEverything.working,
    isPageLoaded: state => state.loadedEverything,
    currentPostType: (state, getters) => (getters.getCurrentRoute.meta && getters.getCurrentRoute.meta.post_type) ? getters.getCurrentRoute.meta.post_type : 'page',

    //getCategory: (state, getters) => taxonomy => (state.taxonomies && state.taxonomies[taxonomy]) ? state.taxonomies[taxonomy] : [],
    getPlaceholder: () => (type) =>{
        const placeholders = WPVUE.options.placeholder_images || false;
        if(!placeholders) return false;
        return placeholders[type] || false;
    },
    getCategory: (state) => (catID, taxonomy) => {
        const tax = taxonomy ? taxonomy : 'category';
        if (!catID) return null;
        catID = Number(catID)
        if (state.taxonomies && state.taxonomies[tax]) {
            return state.taxonomies[tax].filter(cat => (cat.id === catID) ? cat : false)[0]
        } else return null;
    },

    getTaxonomy: state => taxonomy => {
        let tax = null;
        if (!taxonomy) taxonomy = 'category';
        if (state.taxonomies && state.taxonomies[taxonomy] && state.taxonomies[taxonomy].length > 0) tax = state.taxonomies[taxonomy]
        return tax;
    },

    getNavigation: state => navigationLocation => (state.navigations[navigationLocation]) || null,

    //currentPostType: (state, getters) => (getters.getCurrentRoute.meta && getters.getCurrentRoute.meta.post_type) ? getters.getCurrentRoute.meta.post_type : 'page',

    currentPage: (state, getters) => {

        const postType = getters.currentPostType;
        const router = getters.getCurrentRoute;

        let page = null
        let pageToFind = null;

        /* if (router.query && router.query.preview && router.query.preview === 'true' && router.query.page_id) {
            pageToFind = Number(router.query.page_id);
            console.info('Preview');
        } */

        const getPageById = pageId => state.postsData['page'].find(it => (pageId) === it.id)

        if (state.postsData && postType) {

            const pagePath = router.path.replace(/\/$/, "")
            const pageUrl = WPVUE.home_url + '' + pagePath

            switch (router.meta.type) {

                case 'single':
                    page = (state.postsData[postType]) ? state.postsData[postType].find(it => (pageUrl.replace(/\/$/, "") === it.link.replace(/\/$/, ""))) : ''
                    break;

                case 'archive':
                    page = getPageById(getArchiveIdByPostType(postType))
                    break;

                case 'frontPage':
                    page = getPageById(getFrontPageID(postType))
                    break;

                default:
                    break;
            }
        }
        return page;
    },

    currentPageID: (state, getters) => {
        if (getters.currentPage) return getters.currentPage.id
        if (state.route.name === 'frontPage') return Number(WPVUE.front_page)
        if (state.route.name === 'archivePost') return Number(WPVUE.post_page)
        else return null
    },

    getCurrentPageMeta: (state, getters) => {
        if (getters.currentPage && getters.currentPage.seo) {
            const yoast = getters.currentPage.seo,
                page = getters.currentPage;
            if (!page) return null;
            const
                type = getters.getCurrentRoute,
                title = (yoast.yoast_wpseo_title) ? yoast.yoast_wpseo_title : page.title.rendered,
                image = (page.featured_image_src) ? page.featured_image_src.url : "",
                desc = (yoast.yoast_wpseo_metadesc) ? yoast.yoast_wpseo_metadesc : page.post_excerpt,
                author = null,
                // author = (getters.getAuthorByID(page.post_author) && getters.getAuthorByID(page.post_author).title.rendered) ? getters.getAuthorByID(page.post_author).title.rendered : '',
                seo = {
                    title: title,
                    description: desc,
                    keywords: (yoast['yoast_wpseo_focuskw']) ? yoast['yoast_wpseo_focuskw'] : title,
                    author: author,
                    url: page.link,
                    site_name: window.WPVUE.site_name,
                    og: {
                        title: (yoast['yoast_wpseo_opengraph-title']) ? yoast['yoast_wpseo_opengraph-title'] : title,
                        image: (yoast['yoast_wpseo_opengraph-image']) ? yoast['yoast_wpseo_opengraph-image'] : image,
                        type: 'website',
                        description: (yoast['yoast_wpseo_opengraph-description']) ? yoast['yoast_wpseo_opengraph-description'] : desc,
                        url: page.link,
                        site_name: window.WPVUE.site_name,
                    },
                    twitter: {
                        description: (yoast['yoast_wpseo_twitter-description']) ? yoast['yoast_wpseo_twitter-description'] : desc,
                        title: (yoast['yoast_wpseo_twitter-title']) ? yoast['yoast_wpseo_twitter-title'] : title,
                    }
                }


            return seo
        } else {
            return false;
        }
    },

    getPostById: (state) => (postID) => {
        if (!postID) return false;

        postID = Number(postID);
        if (!(typeof postID == 'number')) {
            console.warn('ID must be a number');
            return false;
        }
        let post = undefined;
        for (let postType in state.postsData) {
            post = state.postsData[postType].find(posts => Number(posts.id) === Number(postID));
            if (!(typeof post == 'undefined')) break;
        }

        return post;
    },

    getPosts: state => (postsCats, postType, exclude) => {
        let posts = null;
        if (!postType) postType = 'post'
        if (state.postsData[postType] && state.postsData[postType].length > 0) {
            if (postsCats) { // check if get only from categories
                //check if it is array
                if (!(postsCats.constructor.toString().indexOf("Array") > -1)) { postsCats = [postsCats] }
                posts = state.postsData[postType].filter(item => {
                    if (item.acf._categories && item.acf._categories.length > 0) {
                        return item.acf._categories.some(r => postsCats.includes(r))
                    }
                })
            } else {
                posts = state.postsData[postType]
            }
        }
        return (posts && posts.length > 0) ? posts : null;
    },

    getProjects: state => (postsCats, postType, exclude) => {
        let posts = null;
        if (!postType) postType = 'projects'
        if (state.postsData[postType] && state.postsData[postType].length > 0) {
            if (postsCats) { // check if get only from categories
                //check if it is array
                if (!(postsCats.constructor.toString().indexOf("Array") > -1)) { postsCats = [postsCats] }
                posts = state.postsData[postType].filter(item => {
                    if (item.acf._categories && item.acf._categories.length > 0) {
                        return item.acf._categories.some(r => postsCats.includes(r))
                    }
                })
            } else {
                posts = state.postsData[postType]
            }
        }
        return (posts && posts.length > 0) ? posts : null;
    },

    getServices: state => (postsCats, postType, exclude) => {
        let posts = null;
        if (!postType) postType = 'services'
        if (state.postsData[postType] && state.postsData[postType].length > 0) {
            if (postsCats) { // check if get only from categories
                //check if it is array
                if (!(postsCats.constructor.toString().indexOf("Array") > -1)) { postsCats = [postsCats] }
                posts = state.postsData[postType].filter(item => {
                    if (item.acf._categories && item.acf._categories.length > 0) {
                        return item.acf._categories.some(r => postsCats.includes(r))
                    }
                })
            } else {
                posts = state.postsData[postType]
            }
        }
        return (posts && posts.length > 0) ? posts : null;
    },

    getMachines: state => (postsCats, postType, exclude) => {
        let posts = null;
        if (!postType) postType = 'machines'
        if (state.postsData[postType] && state.postsData[postType].length > 0) {
            if (postsCats) { // check if get only from categories
                //check if it is array
                if (!(postsCats.constructor.toString().indexOf("Array") > -1)) { postsCats = [postsCats] }
                posts = state.postsData[postType].filter(item => {
                    if (item.acf._categories && item.acf._categories.length > 0) {
                        return item.acf._categories.some(r => postsCats.includes(r))
                    }
                })
            } else {
                posts = state.postsData[postType]
            }
        }
        return (posts && posts.length > 0) ? posts : null;
    },

}